<form class="form" [formGroup]="form">

  @if (step === 'choose-base') {
    <div class="form-section">
      <div class="form-section-info">
        <h4>Choose Base Template</h4>
        <div class="description">Start from an existing template or create a blank one.</div>
      </div>
      <div class="form-section-content flex">
        <div class="form-item">
          <div class="form-item-content templates">
            @if (loadingTemplates) {
              <div class="loading">
                <p-progressSpinner></p-progressSpinner>
                <div class="spinnerlabel">Loading templates...</div>
              </div>
            }
            <div class="template blank-template" (click)="selectBase(blankTemplate)">
              <div class="template-label">Blank Template</div>
              <div class="template-description">Start from scratch with a minimal template</div>
            </div>
            @for (template of availableTemplates; track template.id) {
              <div class="template" (click)="selectBase(template)">
                <div class="template-label">{{ template.name }}</div>
                <div class="template-description">{{ template.description || '' }}</div>
                <div class="template-meta">
                  @if (template.language) {
                    <div>{{ template.language }}</div>
                  }
                </div>
              </div>
            }
          </div>
        </div>
      </div>
    </div>
  }

  @if (step === 'edit') {
    <div class="form-section">
      <div class="form-section-info">
        <h4>Template Details</h4>
        <div class="description">Set the name and description for your template.</div>
      </div>
      <div class="form-section-content flex">
        <div class="form-item">
          <div class="form-label">Template Name</div>
          <div class="form-item-content">
            <input pInputText formControlName="name" class="template-name-input" placeholder="Template name" />
          </div>
        </div>
        <div class="form-item">
          <div class="form-label">Description</div>
          <div class="form-item-content">
            <input pInputText formControlName="description" class="template-name-input" placeholder="Optional description" />
          </div>
        </div>
        <div class="form-item">
          <div class="form-label">Language</div>
          <div class="form-item-content">
            <input pInputText formControlName="language" class="template-name-input" placeholder="e.g. en" />
          </div>
        </div>
      </div>
    </div>

    <div class="form-section">
      <div class="form-section-info">
        <h4>Report Section Generators</h4>
        <div class="description">Add, remove, or rename the top-level sections of this template.</div>
      </div>
      <div class="form-section-content flex">
        <div class="form-item">
          <div class="form-item-content">
            <wm-report-section-generators
              [generatorConfigs]="sections"
              [currentFormGroup]="subsectionsFormGroup"
              [allowEdit]="true"
              (generatorsChanged)="onGeneratorsChanged($event)">
            </wm-report-section-generators>
          </div>
        </div>
      </div>
    </div>

    @if (errorMessage) {
      <div class="error-message">{{ errorMessage }}</div>
    }

    <div class="buttons">
      @if (!saving) {
        <p-button label="Save Template" styleClass="p-button-primary" (click)="save()" [disabled]="!form.valid || !form.value.name">
          <fa-icon [icon]="faSave"></fa-icon>
        </p-button>
      }
      @if (saving) {
        <p-button label="Saving..." styleClass="p-button-primary" [disabled]="true">
          <fa-icon [icon]="faSave" [animation]="'spin'"></fa-icon>
        </p-button>
      }
    </div>
  }

</form>
